import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Stack, Typography, Button, Box } from '@mui/material'
import TimerOffRoundedIcon from '@mui/icons-material/TimerOffRounded'
import { Link } from 'react-router-dom'

export function TimeTrackingDisabled() {
  useLingui()

  return (
    <Box sx={{ bgcolor: 'grey.50', minHeight: '100%' }}>
      <Stack alignItems="center" justifyContent="center" spacing={2.5} sx={{ minHeight: 'calc(100vh - 200px)' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
            color: 'text.secondary',
          }}
        >
          <TimerOffRoundedIcon sx={{ fontSize: 40 }} />
        </Box>
        <Stack spacing={1} alignItems="center" sx={{ maxWidth: 400, textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
            <Trans>Time tracking is not enabled</Trans>
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <Trans>Enable time tracking in your settings to start recording your working hours.</Trans>
          </Typography>
        </Stack>
        <Button
          component={Link}
          to="/configuration?tab=time-tracking"
          variant="contained"
          color="primary"
          sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 1.5, boxShadow: 'none' }}
        >
          <Trans>Go to settings</Trans>
        </Button>
      </Stack>
    </Box>
  )
}
